exports.components = {
  "component---src-layouts-error-jsx": () => import("./../../../src/layouts/error.jsx" /* webpackChunkName: "component---src-layouts-error-jsx" */),
  "component---src-layouts-page-jsx": () => import("./../../../src/layouts/page.jsx" /* webpackChunkName: "component---src-layouts-page-jsx" */),
  "component---src-pages-foo-tsx": () => import("./../../../src/pages/foo.tsx" /* webpackChunkName: "component---src-pages-foo-tsx" */)
}

